export default {
	text: "{changedBy} changed this goal's start date from {from} to {to}",
};
